import {connect} from "react-redux";
import ViewListing from "./view";
import {bindActionCreators} from "redux";
import {
    viewMaterial,
    MrfApproval
} from "../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
    viewMaterialDetails: state.MaterialRequistionForm.viewMaterial,
    materialApprovalDetails: state.MaterialRequistionForm.materialApproval,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            viewMaterial,
            MrfApproval
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ViewListing);
